




















































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { enumData, loading, userPrefPageSize } from '@/decorators';
import moment, { Moment } from 'moment';
import excel from '@/utils/excel';
import applyInvoice from './components/applyInvoice.vue';
import billingDeadlineRuleComponent from './components/billingDeadlineRule.vue';
@Component({
  components: {
    applyInvoice,
    billingDeadlineRule: billingDeadlineRuleComponent,
  },
})
export default class ReconciliationBillPage extends Vue {
  // 列表数据
  protected dataList: TypeReconciliationBill.ListItem[] = [];
  // 表格列
  protected columns: TypeBase.TableColumn[] = [];
  protected loadingStatus: boolean = false;

  // 列表勾选
  protected rowSelection: TypeBase.RowSelection = {};
  // 选中的项
  protected selectedList: number[] = [];
  // 账单确认
  @enumData('Finance/ReconciliationResultEnum')
  protected checkResultsData: TypeBase.EnumListItem[] = [];
  // 对账单状态
  @enumData('Finance/ReconciliationStatusEnum')
  protected checkStateData: TypeBase.EnumListItem[] = [];
  // 处理状态
  @enumData('Finance/HandlerStatusEnum')
  protected treatmentStateData: TypeBase.EnumListItem[] = [];
  // 回执状态
  protected returnReceiptStateData: TypeBase.EnumListItem[] = [
    { label: '未上传', value: 1 },
    { label: '已上传', value: 0 },
  ];
  // 发票状态
  @enumData('Finance/ReconciliationStateEnum')
  protected invoiceStateData: TypeBase.EnumListItem[] = [];
  // 确认方式
  @enumData('Finance/ConfirmTypeEnum')
  protected confirmWayData: TypeBase.EnumListItem[] = [];
  // 搜索项
  protected searchData: TypeReconciliationBill.SearchData = this.getInitSearchData();
  // 上一次请求参数
  protected lastParams: TypeReconciliationBill.SearchData = {};
  // 账户列表
  protected accountList: any = [];
  // 当前行数据
  protected selectedListItem: TypeReconciliationBill.ListItem[] = [];
  // 页码总数
  protected total: number = 0;
  protected applyInvoiceSuccess: boolean = false;

  //protected datetimeDefaultValue: Moment[] = this.$util.getDefaultTimeCondition();
  protected datetimeDefaultValue: Moment[] = [];
  @Watch('datetimeDefaultValue', { immediate: true })
  protected onDatetimeDefaultValueChange(arr: Moment[]): void {
     if (arr.length) {
      //  this.searchData.begin_bill_to_time = this.$util.formatDateTime(arr[0]);
      //  this.searchData.end_bill_to_time = this.$util.formatDateTime(arr[1]);
      this.searchData.bill_start_time = this.$util.formatDateTime(arr[0]);
      this.searchData.bill_end_time = this.$util.formatDateTime(arr[1]);
     } else {
      // this.searchData.begin_bill_to_time = '';
      // this.searchData.end_bill_to_time = '';
      this.searchData.bill_start_time = '';
      this.searchData.bill_end_time = '';
    }
  }

  protected created(): void {
    const h = this.$createElement;
    this.columns = [
     //【R316】新增客户账单模板项目 产品要求隐藏
      // {
      //   title: this.t('对账单'),
      //   dataIndex: 'reconciliation_number',
      //   scopedSlots: { customRender: 'reconciliationNumbers' },
      // },
      {
        title: this.t('账单号'),
        dataIndex: 'bill_number_list',
        scopedSlots: { customRender: 'billNumbers' },
      },
      {
        title: this.t('主体信息'),
        dataIndex: 'sign_body_info',
        scopedSlots: { customRender: 'signBody' },
      },
      {
        title: this.t('期初余额'),
        align: 'right',
        dataIndex: 'start_balance',
        scopedSlots: { customRender: 'startBalances' },
      },
      {
        title: this.t('期末余额'),
        align: 'right',
        dataIndex: 'end_balance',
        scopedSlots: { customRender: 'endBalances' },
      },
      {
        title: this.t('账单周期'),
        dataIndex: 'bill_from_time',
        scopedSlots: { customRender: 'billTime' },
      },
      {
        title: this.t('总金额'),
        align: 'right',
        dataIndex: 'all_total',
        scopedSlots: { customRender: 'allTotal' },
      },
      {
        title: <div>
                {this.t('不开票金额')}
            <a-popover content={this.t('不开票金额：该部分金额不计入开票范围，包括但不限于\n' +
                  '1.代金券：代金券兑换抵扣的消费金额\n' +
                  '2.保证金&押金：收取保证金、押金时暂不开具发票；后续实际用于订单消费的，可根据实际消费金额及相关税收法规开具发票。')}>
            <a-icon type='question-circle' class='ml-5' style='vertical-align: middle' />
            </a-popover>
            </div>,
        dataIndex: 'non_invoiceable_amount_list',
        align: 'right',
        scopedSlots: { customRender: 'nonInvoiceableAmountList' },
      },
      {
        title: this.t('应开票金额'),
        align: 'right',
        dataIndex: 'pending_amount_list',
        scopedSlots: { customRender: 'pendingAmountList' },
      },
      {
        title: this.t('账单确认结果'),
        dataIndex: 'confirm_result_type',
        scopedSlots: { customRender: 'confirmResult' },
      },
      {
        title: this.t('账单确认状态'),
        dataIndex: 'reconciliation_status',
        scopedSlots: { customRender: 'reconciliationStatus' },
      },
      {
        title: this.t('操作'),
        dataIndex: 'bi_chargeable_time',
        width: 80,
        fixed: 'right',
        scopedSlots: { customRender: 'operation' },
      },
    ];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: (selectedRowKeys: number[], rowSelection: TypeReconciliationBill.ListItem[]) => {
        this.rowSelection.selectedRowKeys = this.selectedList = selectedRowKeys;
        this.selectedListItem = [...rowSelection];
        this.selectedListItem = this.selectedListItem.filter((item: TypeReconciliationBill.ListItem) => {
          return this.selectedList.indexOf(item.reconciliation_id) > -1;
        });
      },
    };
    this.queryReconciliationList();
    this.queryAccountList();
  }
  // 对账单列表
  @loading('loadingStatus')
  protected async queryReconciliationList(): Promise<void> {
    this.lastParams = this.$util.deepCopy(this.searchData);
    const { data } = await this.$api.finance.queryReconciliationList<TypeBase.ListResult<TypeReconciliationBill.ListItem[]>>(this.searchData);
    const { list, total } = data;
    this.dataList = list;
    this.total = total;
  }

  // 获取账户列表
  protected async queryAccountList(): Promise<void> {
    const { data = [], code } = await this.$api.finance.queryAccountList<TypeBase.AccountItem[]>();
    this.accountList = data;
  }
  // 获取初始搜索
  @userPrefPageSize('reconciliationList')
  protected getInitSearchData(): TypeReconciliationBill.SearchData {
    return {
      page_index: 1,
      page_size: 10,
      code_field: 'bill_number',
      code_value: undefined,
      account_code: undefined,
      reconciliation_result: undefined,
      reconciliation_status: undefined,
      handler_status: undefined,
      reply_status: undefined,
      confirm_type: undefined,
      begin_bill_to_time: undefined,
      end_bill_to_time: undefined,
      bill_start_time: undefined,
      bill_end_time: undefined,
      timeArr: [],
    };
  }
  // 页码变动
  protected handlePageChange(val: number): void {
    this.searchData.page_index = val;
    this.queryReconciliationList();
  }
  // 点击每个tab的回调
  protected handleTabChange(key: string): void {
    this.initPage();
    this.queryReconciliationList();
  }
  // 重置页面数据
  protected initPage(): void {
    this.searchData.page_index = 1;
    this.selectedList = [];
    this.rowSelection.selectedRowKeys = [];
  }
  // 搜索按钮
  protected handleSearch(): void {
    this.initPage();
    this.queryReconciliationList();
  }
  // 清空
  protected handleReset(): void {
    this.searchData = this.getInitSearchData();
    this.initPage();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(() => this.queryReconciliationList());
  }
  // 导出
  protected async handleExport(isAll: boolean): Promise<void> {
    let postData: TypeReconciliationBill.ExportSearchData = {};
    if (isAll) {
      postData = { ...this.lastParams };
      delete postData.page_index;
      delete postData.page_size;
      postData.export = 1;
      postData.id_list = [];
    } else {
      if (!this.selectedList.length) {
        return this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip));
      }
      postData.export = 2;
      postData.id_list = this.selectedList;
    }
    const { code, data, message } = await this.$api.finance.queryReconciliationExport<TypeBase.ExcelDataResult>(postData);
    if (code === 0) {
      this.$util.exportExcel(data);
    } else {
      this.$message.error(message);
    }
  }
  // 申请开票
  protected handleApplyInvoice(): TypeBase.MessageResultFunc | void {
    console.log(this.selectedListItem);
    if (!this.selectedListItem.length) {
      return this.$message.warning(this.t('请选择要开发票的对账单'));
    }
    // 选中项是否是同一个主体
    const signBody = this.selectedListItem.map((item: any) => (item.sign_body_info || {}).account_code + (item.sign_body_info || {}).service_body_name);
    const signBodySet = new Set(signBody.filter((item: string) => item !== undefined));
    if (signBodySet.size !== 1) {
      return this.$message.warning(this.t('仅支持同一主体的对账单批量开票'));
    }
    // 选中项是已开过票
    const hasInvoiceList = this.selectedListItem.filter((item: TypeReconciliationBill.ListItem) => item.is_has_invoice === true);
    if (hasInvoiceList.length > 0) {
      const reconciliationNumberList: string[] = hasInvoiceList.map((item: TypeReconciliationBill.ListItem) => item.reconciliation_number);
      const reconciliationNumber = reconciliationNumberList.join();
      return this.$message.warning(this.t('[{0}]已申请过开票，请重新选择', [reconciliationNumber]));
    }
    // 选中项是否是已处理状态
    const reconciliationStatusList = this.selectedListItem.filter(
      (item: TypeReconciliationBill.ListItem) => item.reconciliation_status !== this.$enum.finance.ReconciliationStatusEnum.CONFIRMED
    );
    if (reconciliationStatusList.length > 0) {
      return this.$message.warning(this.t('只有已确认的对账单支持开票，请重新选择!'));
    }
    // 显示申请窗口
    const applyInvoiceMsg = this.$refs.applyInvoiceRef as applyInvoice;
    applyInvoiceMsg.visible = true;
  }
  // 申请成功
  protected handleApplyInvoiceSuccess(): void {
    // 显示申请成功窗口
    this.applyInvoiceSuccess = true;
    this.queryReconciliationList();
  }
  protected handleToInvoicePage(): void {
    this.applyInvoiceSuccess = false;
    this.$router.push({
      name: 'InvoiceListPage',
      params: {
        noCache: '1',
      },
    });
  }
  /**
   * 显示开票期限规则弹窗
   */
  protected handleShowBillingDeadlineRule(): void {
    const billingDeadlineRuleRef = this.$refs.billingDeadlineRuleRef as billingDeadlineRuleComponent;
    if (billingDeadlineRuleRef) {
      billingDeadlineRuleRef.visible = true;
    }
  }
  protected handleToBillDataPage(): void {
    this.$router.push({
      name: 'BillDataPage',
      params: {
        noCache: '1',
      },
    });
  }
}
